import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import config from './config.js';

const ExpiredSubscription = () => {

  const handleRenew = () => {
    window.location.href = config.SaasUrl;
  };

  return (
    <div className="modern-page" style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ textAlign: 'center', color: 'darkred' }}>
        <FontAwesomeIcon icon={faExclamationTriangle} size="3x" />
        <h1>Your subscription has expired!</h1>
        <p>To continue accessing Iassets, an administrator needs to renew the subscription through the following link.</p>
        <button onClick={handleRenew} style={{ fontSize: '16px', padding: '10px 20px', color: '#fff', backgroundColor: 'green', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
          Renew Subscription
        </button>
      </div>
    </div>
  );
};

export default ExpiredSubscription;
